import { trackViewPromotion } from '.';
import { IItem } from './interfaces';

const DELAY = 1500;

class PromotionInterceptor {
    _items: IItem[] = [];
    _viewed: string[] = [];
    _listName = '';
    _updatingStarted = false;

    addPromotion(activity: IItem, promotion_name?: string) {
        const { item_list_name, item_id } = activity;

        console.log('ga compare', item_list_name, this._listName);
        //console.log('ga compare index', index, !this._viewed.includes(index));
        console.log('ga compare _viewed', this._viewed);

        if (this._listName !== item_list_name) {
            this._listName = item_list_name || '';
            this._viewed = [];
        }

        if (!this._viewed.includes(item_id)) {
            this._viewed.push(item_id);
            this._items.push(activity);
        }

        if (!this._updatingStarted) {
            this._updatingStarted = true;

            setTimeout(() => {
                if (this._items.length) {
                    trackViewPromotion({
                        items: this._items,
                        promotion_name,
                    });
                    this._items = [];
                    this._viewed = [];
                }

                this._updatingStarted = false;
            }, DELAY);
        }
    }
}

export const promotionInterceptor = new PromotionInterceptor();
